import PaymentDetails from "components/field/payment/PaymentDetails"

export const formFieldTypes = [{ val: "paymentDetails", label: "Detalii plata" }]
export const formFields = {
    paymentDetails: PaymentDetails,
}
